import { useTranslation } from 'react-i18next';

interface CTAProps {
  onBookClick: () => void;
}

export default function CTA({ onBookClick }: CTAProps) {
  const { t } = useTranslation();

  return (
    <section className="relative py-24 md:py-40 overflow-hidden">
      {/* Full-bleed background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1dc1d3e5b34b9b8a868fcb7c9b8f8b83.jpg"
          alt="Istanbul luxury"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/75 to-black/50" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-10 h-px bg-amber-400/50" />
            <span
              className="text-amber-400/80 text-xs font-medium tracking-[0.25em] uppercase"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Take the step
            </span>
          </div>

          <h2
            className="text-5xl md:text-7xl lg:text-8xl font-normal text-white leading-[1.0] mb-8"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {t('cta.title.line1')}
            <br />
            <em className="text-amber-300 not-italic">{t('cta.title.line2')}</em>
          </h2>

          <p
            className="text-white/50 text-lg md:text-xl font-light mb-12 max-w-xl leading-relaxed"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            {t('cta.subtitle2')}
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-4 mb-14">
            <button
              onClick={onBookClick}
              className="flex items-center gap-3 bg-amber-400 hover:bg-amber-300 text-black px-10 py-4 font-bold text-sm tracking-widest uppercase transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              {t('cta.button.primary')}
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => window.open('https://wa.me/message/OAKDCTBVIML6F1', '_blank')}
              className="flex items-center gap-3 border border-white/20 hover:border-amber-400/50 text-white/60 hover:text-amber-400 px-10 py-4 font-medium text-sm tracking-widest uppercase transition-all cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              <i className="ri-whatsapp-line"></i>
              {t('cta.button.secondary')}
            </button>
          </div>

          {/* Trust badges */}
          <div className="flex flex-wrap gap-8 text-white/30 text-xs tracking-widest uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-amber-400/50"></i>
              <span>{t('cta.badge1')}</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-hand-heart-line text-amber-400/50"></i>
              <span>{t('cta.badge2')}</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-chat-smile-2-line text-amber-400/50"></i>
              <span>{t('cta.badge3')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
